import {
  USER_GET_CART_ITEMS_LOADING,
  USER_GET_CART_ITEMS_SUCCESS,
  USER_GET_CART_ITEMS_FAILURE,
} from "redux/types";

const initialState = {
  userGetCartItemsLoading: false,
  userCartItems: null,
  errors: null,
};

export const userGetCartItemsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case USER_GET_CART_ITEMS_LOADING:
      return { ...state, userGetCartItemsLoading: action.payload };
    case USER_GET_CART_ITEMS_SUCCESS:
      // console.log("Updated state:", action.payload);
      return { ...state, userCartItems: action.payload };
    case USER_GET_CART_ITEMS_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
